// extracted by mini-css-extract-plugin
export default {"startOverButton__button":"startOverButton__button___w__PE","startOverButton__icon":"startOverButton__icon___VEtK5"};